<template>
  <a-modal title="添加"
           :open="modal"
           :confirm-loading="loading"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">
    <a-form ref="form"
            size="small"
            :rules="rules"
            :model="entity"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 20 }">
      <a-form-item label="名称" name="name">
        <a-input v-model:value="entity.name"/>
      </a-form-item>

      <a-form-item label="正面" name="thumbnail">
        <a-space>
          <a-input v-model:value="entity.thumbnail"/>
          <a-button type="primary" @click="thumbPickCk('thumbnail')">选择</a-button>
        </a-space>
      </a-form-item>

      <a-form-item label="背面" name="backThumbnail">
        <a-space>
          <a-input v-model:value="entity.backThumbnail"/>
          <a-button type="primary" @click="thumbPickCk('backThumbnail')">选择</a-button>
        </a-space>
      </a-form-item>

      <a-form-item label="朝向" name="dir">
        <a-radio-group v-model:value="entity.dir" name="radioGroup">
          <a-radio :value="0">竖</a-radio>
          <a-radio :value="-1">-90度横</a-radio>
          <a-radio :value="1">90度横</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="稀有度" name="rare">
        <a-input-number min="0" v-model:value="entity.rare"/>
      </a-form-item>

      <a-form-item label="库存" name="stock">
        <a-input-number min="0" v-model:value="entity.stock"/>
      </a-form-item>

      <a-form-item label="概率" name="chance">
        <a-input-number min="0" v-model:value="entity.chance"/>
      </a-form-item>

      <a-form-item label="父级ID" name="rare">
        <a-input-number min="0" v-model:value="entity.pid"/>
      </a-form-item>

      <a-form-item label="最高等级" name="max">
        <a-input-number min="0" v-model:value="entity.max"/>
      </a-form-item>

      <a-form-item label="素材数" name="require">
        <a-input-number min="0" v-model:value="entity.require"/>
      </a-form-item>

      <a-form-item label="限编" name="limit">
        <a-input-number min="0" v-model:value="entity.limit"/>
      </a-form-item>
    </a-form>
  </a-modal>

  <thumb-pick-modal ref="thumbPick" @choose="handleChoose"/>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

import ThumbPickModal from '@/components/ThumbPick'

const emits = defineEmits(['refresh'])

const modal = ref(false)
const loading = ref(false)
const form = ref(null)
const thumbPick = ref(null)
const entity = ref({
  name: '',
  thumbnail: '',
  backThumbnail: '',
  dir: 0,
  pid: 0,
  rare: 0,
  stock: 0,
  chance: 0,
  limit: 0,
  max: 0,
  require: 0,
})

const rules = {
  name: [{
    required: true,
    message: '名称不能为空',
    trigger: 'blur'
  }],
  thumbnail: [{
    required: true,
    message: '正面不能为空',
    trigger: 'blur'
  }],
  backThumbnail: [{
    required: true,
    message: '背面不能为空',
    trigger: 'blur'
  }],
  pid: [{
    required: true,
    message: '父级ID不能为空',
    trigger: 'blur'
  }],
  rare: [{
    required: true,
    message: '稀有度不能为空',
    trigger: 'blur'
  }],
  stock: [{
    required: true,
    message: '库存不能为空',
    trigger: 'blur'
  }],
  chance: [{
    required: true,
    message: '库存不能为空',
    trigger: 'blur'
  }],
  limit: [{
    required: true,
    message: '限编不能为空',
    trigger: 'blur'
  }],
  max: [{
    required: true,
    message: '最高等级不能为空',
    trigger: 'blur'
  }],
  require: [{
    required: true,
    message: '素材数不能为空',
    trigger: 'blur'
  }],
}

let album = 0

function openCk(albumId) {
  album = albumId
  modal.value = true
}

function okCk() {
  loading.value = true

  form.value.validate().then(() => {
    let data = {...entity.value}
    data.album = album

    axios.post('/card', data).then((res) => {
      loading.value = false

      if (res.code === 1) {
        emits('refresh')
        modal.value = false
        form.value.resetFields()
      }
    })
  }).catch(() => {
    loading.value = false
  })
}

function cancelCk() {
  modal.value = false
  form.value.resetFields()
  loading.value = false
}

function thumbPickCk(key) {
  thumbPick.value.openCk(key)
}

function handleChoose(v, f) {
  if (f === 'thumbnail') {
    entity.value.thumbnail = v
  } else if (f === 'backThumbnail') {
    entity.value.backThumbnail = v
  }
}

defineExpose({openCk})
</script>
